import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source']
  static values = { swap: Number, pause: Number }

  connect() {
    this.swap = Number(this.element.dataset.animatedSourcesSwapValue)
    this.pause = Number(this.element.dataset.animatedSourcesPauseValue)
    this.opacity = this.swap * 0.9

    this.element.style.setProperty('--scale-time', `${this.swap}ms`)
    this.element.style.setProperty('--opacity-time', `${this.opacity}ms`)

    this.even = this.sourceTargets.filter(el =>
      el.classList.contains('is-even')
    )
    this.odd = this.sourceTargets.filter(el => el.classList.contains('is-odd'))

    this.run()
  }

  async run() {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      await this.animateGroup(this.even, 'b')
      await this.sleep(this.pause)
      await this.animateGroup(this.even, 'a')
      await this.sleep(this.pause)
      await this.animateGroup(this.odd, 'b')
      await this.sleep(this.pause)
      await this.animateGroup(this.odd, 'a')
      await this.sleep(this.pause)
    }
  }

  async animateGroup(group, target) {
    await Promise.all(group.map(el => this.toggleSource(el, target)))
  }

  async toggleSource(source, target) {
    const a = source.querySelector('.animated-sources__img--a')
    const b = source.querySelector('.animated-sources__img--b')
    const state = source.dataset.state || 'a'

    const next = target === 'b' && state === 'a'
    const prev = target === 'a' && state === 'b'

    if (!next && !prev) return

    const hide = next ? a : b
    const show = next ? b : a

    source.classList.add('is-scale')
    hide.classList.add('animated-sources__img--hidden')
    await this.sleep(this.swap)
    source.classList.remove('is-scale')
    show.classList.remove('animated-sources__img--hidden')
    await this.sleep(this.swap)
    source.dataset.state = next ? 'b' : 'a'
  }

  sleep(ms) {
    return new Promise(r => setTimeout(r, ms))
  }
}
